/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.keywords.init());

App.keywords = {

  init() {
    return $(document)
      .off('keyup keypress change', '.js-keyword-field', App.utils.debounce(App.keywords.check_availability, 250))
      .on('keyup keypress change', '.js-keyword-field', App.utils.debounce(App.keywords.check_availability, 250))

      .off('click', '.js-group-labels-show-more', App.keywords.show_more_clicked)
      .on('click', '.js-group-labels-show-more', App.keywords.show_more_clicked);
  },

  check_availability(evt) {
    const $keyword = $(evt.target);
    const val = window.encodeURIComponent($keyword.val().replace(/\./g, ''));
    const id = $keyword.attr('data-id') || '';

    if (val.trim().length > 0) {
      return $.getJSON(`/keywords/availability/${val}/${id}`)
        .done(App.keywords.update_availability)
        .fail(function(xhr) {
          console.log('Error in check_availability: ', xhr);
          return App.keywords.update_availability({ available: false });
      });
    }
  },

  update_availability(data, status, jqxhr) {
    // console.log 'in update_availability', data
    const $availability = $('.js-keyword-availability');
    $availability.removeClass('is-available is-not-available checking');

    const $submit_btn = $($availability.data('submit-btn'));
    $submit_btn.prop('disabled', !data.available);

    if (data.reset) { return; }

    if (data.available) {
      return $availability.addClass('is-available');
    } else {
      return $availability.addClass('is-not-available');
    }
  },

  show_more_clicked(evt) {
    evt.preventDefault();
    return $(this).closest('.js-group-labels').toggleClass('expanded');
  }
};
